import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { msgTypes } from "../../data/types/msgTypes";
import { startLogin } from "./functions/startLogin";
import { useDispatch } from "react-redux";
import { stdObject } from "../../data/types/stdObject";
import { resetPasswordModal } from "../MainFrame/data/resetPasswordModal";
import { sendData } from "../../services/sendData";

export default function useLogin({
  isLoading,
  msgType,
  loginPack,
  logoutAction,
}: {
  isLoading: boolean;
  msgType: string;
  loginPack: stdObject;
  logoutAction: () => void;
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loginData, setLoginData] = useState<{
    username: string;
    password: string;
  }>({ username: "", password: "" });
  const [msg, setMsg] = useState<string>("");
  const [msg2, setMsg2] = useState<string>("");
  const [windowValues, setWindowValues] = useState<stdObject>({});
  const fields = ["username", "password"];

  useEffect(() => {
    if (msgType !== "") {
      setTimeout(() => {
        setMsg(msgType);
      }, 10);
    }
  }, []);

  useEffect(() => {
    if (isLoading) {
      setMsg("loading");
    } else {
      closeMsg();
    }
  }, [isLoading]);

  const handleLogin = () => {
    let access = "";
    fields.forEach((e: string) => {
      if (
        access === "" &&
        loginData[e as keyof typeof loginData].trim().length === 0
      ) {
        access = e;
      } else {
        loginData[e as keyof typeof loginData] =
          loginData[e as keyof typeof loginData];
      }
    });
    access === ""
      ? startLogin({
          dispatch,
          loginData,
          cleanData,
          setMsg,
          setWindowValues,
          closeMsg,
          loginPack,
        })
      : setMsg(`${access}Empty`);
  };

  const cleanData = () => {
    setLoginData({ username: "", password: "" });
  };

  const closeMsg = (level: number = 1) =>
    level === 2 ? setMsg2("") : setMsg("");

  const updateData = (key: string, value: string) => {
    setLoginData({ ...loginData, [key]: value });
  };

  const resetUserPassword = async () => {
    if (windowValues.pass1.includes(" ")) {
      setMsg2("passwordNoSpaces");
    } else if (windowValues.pass1.trim().length < 5) {
      setMsg2("passwordAtLeast");
    } else if (windowValues.pass1.trim() !== windowValues.pass2.trim()) {
      setMsg2("passwordsDontMatch");
    } else {
      const payloadResetUserPassword = {
        account: windowValues.account,
        pin: windowValues.token,
        newPass: windowValues.pass1,
      };
      const responseResetUserPassword = await sendData({
        endPoint: "resetUserPassword",
        payload: payloadResetUserPassword,
        logoutAction,
      });
      const { success, status } = responseResetUserPassword;
      if (success && status) {
        setMsg("passwordWasReset");
        setWindowValues({});
      }
    }
  };

  const msgData: msgTypes = {
    loading: { code: "loading" },
    usernameEmpty: { title: t("p.usernameEmpty") },
    passwordEmpty: { title: t("p.passwordEmpty") },
    netWorkError: { code: "error", title: t("p.netWorkError") },
    connectionError: { code: "error", title: t("p.connectionError") },
    restrictedAccess: { code: "error", title: t("p.restrictedAccess") },
    incorrectCredentials: { code: "error", title: t("p.incorrectCredentials") },
    sessionExpired: { code: "warning", title: t("p.sessionExpired") },
    resetPasswordModal: resetPasswordModal({
      t,
      windowValues,
      setWindowValues,
      resetUserPassword,
      closeMsg,
    }),
    passwordNoSpaces: { code: "warning", title: t("p.passwordNoSpaces") },
    passwordAtLeast: {
      code: "warning",
      title: t("p.passwordAtLeast", { number: 5 }),
    },
    passwordsDontMatch: { code: "warning", title: t("p.passwordsDontMatch") },
    passwordWasReset: { title: t("p.passwordWasReset") },
  };

  return {
    loginData,
    updateData,
    handleLogin,
    fields,
    msg,
    msg2,
    msgData,
    closeMsg,
  };
}
